import requestAnimationFrames from "@-/com.npmjs.request-animation-frames";

/**
 * Timestamps of upcoming animation frames, from `request-animation-frames` rather than the global
 * `requestAnimationFrame` (absent in some runtimes, e.g. web SSR in Node, where the package falls
 * back to a ~16 ms timer). Unlike the package's iterable, this skips the timestamp it yields
 * immediately, so every value is an actual frame.
 *
 * Stop with `break`/`return` in the loop body. A pending frame cannot be cancelled from outside the
 * loop: check a cancellation flag at the top of the body instead. Frames do not tick while the app
 * is backgrounded.
 */
export async function* animationFrames(): AsyncGenerator<number, void, undefined> {
  let isFirst = true;
  for await (const timestamp of requestAnimationFrames()) {
    if (isFirst) {
      isFirst = false;
      continue;
    }
    yield timestamp;
  }
}
